import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'applicationSubjectPlaceholder',
  standalone: true
})
export class ApplicationSubjectPlaceholderPipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.service?.url === '/zajecie-pasa-prowadzenie-robot': {
        return 'Wpisz tu ulicę';
      }
      default: {
        return 'Wpisz tu czego dotyczy wniosek';
      }
    }
  }
}
